import React from 'react';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withRouter} from "react-router";
import {connect} from "trim-redux";
import {defaultVariabls} from "../../../../../config";

class SingleStatusCard extends React.Component {
    state = {
        status: this.props.status,
        before: this.props.before,
        current: this.props.current,
        transferType: this.props.transferType,
    };
    classes = this.props.classes;
    componentDidMount(){
        this.setState({
            status: this.props.status,
            before: this.props.before,
            current: this.props.current,
        });
    }
    render(){
        let {before,current,status,transferType} = this.state;
        return (
            <>
                <div className={`singleStatusCard ${before && " before "} ${current &&  " current "}`}>
                    <div className="imgHolder">
                        <img src={`${defaultVariabls.uploads}/FileManager/${status.file.name}.${status.file.extension}`}/>
                    </div>
                    <h3>{transferType==="airplane" ? status.airplane_name : status.ship_name}</h3>
                </div>

            </>
        );
    }
}
const mstp = state => ({
    locale: state.locale,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(SingleStatusCard)))));